const echarts = require("echarts");

export default function (data, name) {
  var fontColor = "#fff";
  return {
    backgroundColor: "",
    textStyle: {
      fontSize: 18,
    },
    title: {
      show: false,
      text: "",
      left: "left",
      textStyle: {
        color: fontColor,
        align: "center",
      },
    },
    grid: {
      left: "20",
      right: "20",
      bottom: "20",
      top: "50",
      containLabel: true,
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
        label: {
          show: true,
          backgroundColor: "#333",
        },
      },
    },
    legend: {
      show: true,
      x: "center",
      top: "10",
      textStyle: {
        color: fontColor,
        fontSize: "8",
      },
      itemHeight: 10,
      itemWidth: 10,
      data: name,
    },
    xAxis: [
      {
        type: "category",
        boundaryGap: true,
        axisLabel: {
          color: fontColor,
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "rgb(10, 115, 255)",
          },
        },
        data: data.xdata,
      },
    ],
    yAxis: [
      {
        type: "value",
        name: "",
        axisLine: {
          lineStyle: {
            color: fontColor,
          },
        },
        yAxisIndex: 0,
        axisTick: {
          alignWithLabel: true
        },
        splitLine: {
          show: false
        },
        nameTextStyle: {
          color: '#fff',
        },
        axisLabel: {
          color: '#fff',
        },
        axisTick:{
          "show":false //隐藏x轴刻度
        },
        data: [0, 151, 302, 453, 604, 755],
      },
    ],
    series: [
      {
        name: name[0],
        type: "bar",
        stack: "total",
        barWidth: 10,
        label: {
          show: false,
        },
        emphasis: {
          focus: "series",
        },
        itemStyle: {
          normal: {
            color: "rgba(10, 115, 255, 0.8)",
          },
        },
        data: data.ydata1,
      },
      {
        name: name[1],
        type: "bar",
        stack: "total",
        barWidth: 10,
        label: {
          show: false,
        },
        emphasis: {
          focus: "series",
        },
        itemStyle: {
          normal: {
            color: "rgba(61, 171, 255, 0.8)",
          },
        },
        data: data.ydata2,
      },
      {
        name: name[2],
        type: "bar",
        stack: "total",
        barWidth: 10,
        label: {
          show: false,
        },
        emphasis: {
          focus: "series",
        },
        itemStyle: {
          normal: {
            color: "rgba(121, 218, 255, 0.8)",
            barBorderRadius: [10, 10, 0, 0],
          },
        },
        data: data.ydata3,
      },
    ],
  };
}
